var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-combobox',{attrs:{"auto-select-first":"","label":"Observatory","items":_vm.items},model:{value:(_vm.Observatory),callback:function ($$v) {_vm.Observatory=$$v},expression:"Observatory"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }